import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './EditSupportDocumentOutput.css';
import { RiDeleteBin6Fill } from 'react-icons/ri';
import { Input, Button, Drawer, Form, Select } from 'antd';
// import SideClose from "../../../../../Assets/ModalClose.svg";
import {
    SupportingDocumentsFileUploadActionHandler,
    SupportingDocumentsFileUploadClear,
} from '../../../../../Redux/Actions/user/BuildQuickFileUploadAction';
import {
    SupportingDocumentOutputUpdateHandler,
    clearDocumentsSupportingData,
} from '../../../../../Redux/Actions/user/SupportingDocumentsOutputUpdate';
import { workspaces_List_ActionHandler } from '../../../../../Redux/Actions/user/WorkspacesList';
import {
    workspaces_FolderList_ActionHandler,
    workspaces_Support_Documents_OutputList_ActionHandler,
} from '../../../../../Redux/Actions/user/WorkspaceSupportingDocumentList';
import { workspaces_OutputFormatsId_ActionHandler } from '../../../../../Redux/Actions/user/workspacesOutputFormatsId';
import { workspaces_SupportingDocumentsId_ActionHandler } from '../../../../../Redux/Actions/user/workspacesSupportingDocumentsId';
import Loader from '../../../../../Components/Loader/Loader';
const { Option } = Select;
const EditSupportDocumentOutput = ({
    isEditOutputData,
    handleEditClick,
    editOutputData,
    workspace_id,
    folder_id,
    workspaceFolderFlag,
}) => {
    console.log('workspace_id', workspace_id);
    let SideClose = '/assets/ModalClose.svg';
    let dispatch = useDispatch();
    const [workspaceId, setWorkspaceId] = useState(null);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [loader, setLoader] = useState(false);
    const [workspaceFolderId, setworkspaceFolderId] = useState('');
    const [loading, setLoading] = useState(false);
    const formRef = React.createRef();
    const [deleteCode, setDeleteCode] = useState(false);
    const workspaceData = useSelector(
        (state) => state?.workspaces_List_Data?.workspace_create_data?.data
    );
    const workspaceFolderListData = useSelector(
        (state) =>
            state?.workspaces_Supporting_Document_FolderList_Data
                ?.workspace_supporting_document_folderList_data?.data
    );
    const supportingdocumentsfileuploaddata = useSelector(
        (state) =>
            state?.BuildQuickFileUploadData
                ?.supporting_documents_file_upload_data
    );
    const supportingdocumentsoutputupdateddata = useSelector(
        (state) =>
            state?.WorkspaceSupportDocumentsOutputUpdateData
                ?.workspace_support_documents_output_update_data
    );
    const [uploadFileName, setUploadFileName] = useState(
        supportingdocumentsfileuploaddata?.data?.filename
    );
    const [wordCount, setWordCount] = useState(
        supportingdocumentsfileuploaddata?.data?.word_count
    );
    const [content, setContent] = useState(
        supportingdocumentsfileuploaddata?.data?.content
    );
    useEffect(() => {
        if (supportingdocumentsfileuploaddata) {
            setLoader(false);
            setDeleteCode(false);
        }
    }, [supportingdocumentsfileuploaddata]);
    useEffect(() => {
        dispatch(SupportingDocumentsFileUploadClear());
        return () => {
            dispatch(SupportingDocumentsFileUploadClear());
        };
    }, []);
    const handleFileChange = (event) => {
        setLoader(true);
        const file = event.target.files[0];
        const allowedFileExtensions = /\.(pdf|mp3|mp4|txt|doc|docx)$/i;
        if (file && allowedFileExtensions.test(file.name)) {
            const access_token = localStorage.getItem('token');
            dispatch(SupportingDocumentsFileUploadActionHandler(file));
            setUploadedFile(file);
        } else {
            alert('Please select a valid PDF, MP3, or MP4 file.');
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
            setUploadFileName(null);
            setWordCount(null);
            setContent(null);
            setLoader(false);
        }
    };
    const handleDrop = (e) => {
        e.preventDefault();
        setLoader(true);
        const file = e.dataTransfer.files[0];
        if (file) {
            const allowedFileTypes = [
                'application/pdf',
                'audio/mpeg',
                'video/mp4',
                'audio/mp3',
                'text/plain',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/doc',
                'application/docx',
            ];
            if (file && allowedFileTypes.includes(file.type)) {
                dispatch(SupportingDocumentsFileUploadActionHandler(file));
                setUploadedFile(file);
                setTimeout(() => {
                    setLoader(false);
                }, 2000);
            } else {
                alert('Please select a valid PDF, MP3, or MP4 file.');
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
                setUploadFileName(null);
                setWordCount(null);
                setContent(null);
                setLoader(false);
            }
        } else {
            console.error('No file found in dataTransfer.');
            setLoader(false);
        }
    };
    const handleChangeWorkspace = (value) => {
        setworkspaceFolderId(null);
        formRef.current.resetFields(['folder_id']);
        setWorkspaceId(value);
    };
    useEffect(() => {
        dispatch(workspaces_List_ActionHandler('', ''));
        setUploadFileName(supportingdocumentsfileuploaddata?.data?.filename);
        setWordCount(supportingdocumentsfileuploaddata?.data?.word_count);
        setContent(supportingdocumentsfileuploaddata?.data?.content);
    }, [supportingdocumentsfileuploaddata]);

    const fileInputRef = React.createRef();
    const onFinish = (values) => {
        setLoading(true);
        let imageId;
        let imageContent;
        if (supportingdocumentsfileuploaddata) {
            imageId = supportingdocumentsfileuploaddata?.data?.id;
            imageContent = supportingdocumentsfileuploaddata?.data?.content;
        } else {
            imageId = editOutputData.files[0]['id'];
            imageContent = editOutputData.files[0]['content'];
        }
        if (workspace_id) {
            workspace_id = workspace_id;
            folder_id = folder_id;
        } else {
            workspace_id = values.workspace_id;
            folder_id = values.folder_id;
        }
        const submitObject = {
            id: editOutputData.id,
            workspace_id: workspace_id,
            folder_id: workspaceFolderId,
            name: values.name,
            context: values.context,
            type: 'file',
            files: [
                {
                    id: imageId,
                    content: imageContent,
                },
            ],
        };
        dispatch(SupportingDocumentOutputUpdateHandler(submitObject));
    };
    const handleDeleteClick = () => {
        dispatch(SupportingDocumentsFileUploadClear());
        setDeleteCode(true);
        setUploadedFile(null);
        setUploadFileName(null);
        setWordCount(null);
        setContent(null);
    };
    const handleDivClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    useEffect(() => {
        if (supportingdocumentsoutputupdateddata) {
            handleEditClick(false);
            dispatch(clearDocumentsSupportingData());
        }
    }, [supportingdocumentsoutputupdateddata, dispatch]);
    useEffect(() => {
        if (workspaceId) {
            dispatch(
                workspaces_Support_Documents_OutputList_ActionHandler(
                    workspaceId,
                    '',
                    ''
                )
            );
        }
    }, [workspaceId]);
    useEffect(() => {
        setworkspaceFolderId(editOutputData.folder.id);
        return () => {
            setLoading(false);
            dispatch(workspaces_FolderList_ActionHandler(workspace_id, '', ''));
            dispatch(
                workspaces_OutputFormatsId_ActionHandler(workspace_id, '')
            );
            dispatch(
                workspaces_SupportingDocumentsId_ActionHandler(workspace_id, '')
            );
        };
    }, []);
    useEffect(() => {
        if (editOutputData) {
            dispatch(
                workspaces_Support_Documents_OutputList_ActionHandler(
                    editOutputData.folder.workspace_id,
                    '',
                    ''
                )
            );
        }
    }, [editOutputData]);
    let htmlContent = content;

    if (htmlContent != undefined) {
        htmlContent = htmlContent.replace(/\n/g, '<br>');
    }

    let formattedHtml = (
        <div dangerouslySetInnerHTML={{ __html: htmlContent }}></div>
    );
    if (typeof formattedHtml == 'string') {
        formattedHtml = formattedHtml?.split('\n').map((str) => <p>{str}</p>);
    }
    const handleSelect = (value) => {
        setworkspaceFolderId(value);
    };
    const handleChange = (value) => {
        setworkspaceFolderId(value);
    };
    return (
        <>
            <Drawer
                placement='right'
                closable={false}
                onClose={handleEditClick}
                open={isEditOutputData}
                key='right'
                width={'40%'}>
                <img
                    className='edit-refer-data-side-close'
                    src={SideClose}
                    alt=''
                    onClick={handleEditClick}
                />
                {loading && <Loader />}
                {loader ? (
                    <>
                        <div
                            className='loader-workspace'
                            style={{
                                position: 'absolute',
                                left: '50%',
                                top: '50%',
                                zIndex: 1,
                                width: '120px',
                                height: '120px',
                                margin: '-76px 0 0 -76px',
                                border: '16px solid #f3f3f3',
                                borderRadius: '50%',
                                borderTop: '16px solid #3498db',
                                WebkitAnimation: 'spin 2s linear infinite',
                                animation: 'spin 2s linear infinite',
                            }}></div>
                    </>
                ) : null}
                <Form
                    name='uploadComputerForm'
                    initialValues={{
                        name: editOutputData.name,
                        context: editOutputData.context,
                        workspace_id: editOutputData.folder.workspace_id,
                        folder_id: editOutputData.folder.id,
                    }}
                    ref={formRef}
                    onFinish={onFinish}>
                    <div className='edit-refer-data-modal-div'>
                        <h3>Edit Output Format</h3>
                    </div>
                    <div className='edit-refer-data-input'>
                        <div className='edit-refer-data-1'>
                            <label>Supporting document name</label>
                            <Form.Item
                                name='name'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your name!',
                                    },
                                    {
                                        type: 'name',
                                        message: 'Please enter a valid name',
                                    },
                                ]}>
                                <Input placeholder='Enter your name' />
                            </Form.Item>
                        </div>
                        <div className='edit-refer-data-2'>
                            <label>
                                Context to frame reference data (edit if
                                required)
                            </label>
                            <Form.Item
                                name='context'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your context!',
                                    },
                                    {
                                        type: 'name',
                                        message: 'Please enter a valid context',
                                    },
                                ]}>
                                <Input placeholder='Enter your context' />
                            </Form.Item>
                        </div>
                        <div className='edit-refer-data-2'>
                            <label>Reference data</label>
                            <div
                                className='edit-refer-data-img-height-320'
                                onClick={deleteCode ? handleDivClick : null}
                                onDragOver={(e) => e.preventDefault()}
                                onDrop={handleDrop}>
                                <div className='edit-refer-data-main-div'>
                                    <div className='edit-refer-data-span'>
                                        {uploadedFile ? (
                                            <>
                                                <div className='upload-computer-middle-div-first-p'>
                                                    {uploadFileName}
                                                    <RiDeleteBin6Fill
                                                        className='upload-out-computer-delete-svg'
                                                        onClick={
                                                            handleDeleteClick
                                                        }
                                                    />
                                                </div>

                                                <div className='upload-computer-middle-div-second-p'>
                                                    {/* Word Count: */}
                                                    Word Count: {wordCount}
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className='edit-refer-data-middle-div-first-p'>
                                                    {deleteCode
                                                        ? ''
                                                        : editOutputData
                                                              .files[0][
                                                              'filename'
                                                          ]}
                                                    <RiDeleteBin6Fill
                                                        className='upload-computer-delete-svg'
                                                        onClick={
                                                            handleDeleteClick
                                                        }
                                                    />
                                                </div>
                                                <div className='edit-refer-data-middle-div-second-p'>
                                                    Word Count:
                                                    {deleteCode
                                                        ? ''
                                                        : editOutputData
                                                              .files[0][
                                                              'word_count'
                                                          ]}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                                <input
                                    type='file'
                                    ref={fileInputRef}
                                    className='file-none'
                                    onChange={handleFileChange}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                    }}
                                    accept='.pdf, .mp3, .mp4, .txt, .doc, .docx, application/pdf, audio/mp3, video/mp4, text/plain, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                                />
                            </div>
                            {uploadedFile ? (
                                <div className='upload-out-computer-main-content'>
                                    <p>{formattedHtml}</p>
                                </div>
                            ) : (
                                <div className='edit-refer-data-main-content'>
                                    {deleteCode
                                        ? ''
                                        : editOutputData.files[0]['content']}
                                </div>
                            )}
                            {workspaceFolderFlag ? null : (
                                <>
                                    <div className='own-out-data-modal-div'>
                                        <h3>Select Destination Directory</h3>
                                    </div>
                                    <div className='own-out-data-input'>
                                        <div className='own-out-data-1'>
                                            <label>Select Workspace</label>
                                            <Form.Item
                                                name='workspace_id'
                                                rules={[
                                                    {
                                                        required: true,
                                                        message:
                                                            'Please select a workspace!',
                                                    },
                                                ]}>
                                                <Select
                                                    className='uploadcomputer-select'
                                                    onChange={
                                                        handleChangeWorkspace
                                                    }>
                                                    {workspaceData &&
                                                        workspaceData.map(
                                                            (workspace) => (
                                                                <>
                                                                    {!workspace.is_locked && (
                                                                        <Option
                                                                            key={
                                                                                workspace.id
                                                                            }
                                                                            value={
                                                                                workspace.id
                                                                            }>
                                                                            {
                                                                                workspace.name
                                                                            }
                                                                        </Option>
                                                                    )}
                                                                </>
                                                            )
                                                        )}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                        <div className='own-out-data-2'>
                                            <label>Select Folder</label>
                                            <Form.Item
                                                name='folder_id'
                                                rules={[
                                                    {
                                                        required: true,
                                                        message:
                                                            'Please select a folder!',
                                                    },
                                                ]}>
                                                <div>
                                                    <Select
                                                        className='uploadcomputer-select'
                                                        name='folder_id'
                                                        value={
                                                            workspaceFolderId
                                                        }
                                                        onSelect={handleSelect}
                                                        onChange={handleChange}>
                                                        {workspaceFolderListData &&
                                                            workspaceFolderListData.map(
                                                                (folder) => (
                                                                    <Option
                                                                        key={
                                                                            folder.id
                                                                        }
                                                                        value={
                                                                            folder.id
                                                                        }>
                                                                        {
                                                                            folder.name
                                                                        }
                                                                    </Option>
                                                                )
                                                            )}
                                                    </Select>
                                                </div>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </>
                            )}
                            <div className='edit-refer-data-input'>
                                <div className='edit-refer-data-supporting-div'>
                                    <Form.Item>
                                        <Button
                                            type='primary'
                                            htmlType='submit'
                                            block
                                            className='edit-refer-data-supporting-button'>
                                            Edit & Save
                                        </Button>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </Drawer>
        </>
    );
};
export default EditSupportDocumentOutput;
